export default __webpack_public_path__ + "static/media/Motorbike-black-small.6410765d.webp";